export const PERSISTENCE_KEYS = Object.freeze({
  ACCESS: 'access',
  USER_INFO: 'user-info',
  RETURN_TO: 'return-to',
  THEME_MODE: 'theme-mode',
  LAYOUT_WIDTHS: Object.freeze({
    MESSAGE_CENTER: 'message-center-layout-width',
    SEARCH_PROJECTS: 'search-projects-layout-width',
    SOURCING: 'sourcing-layout-width'
  }),
  PROFILE_TABS: Object.freeze({
    CANDIDATES: 'profile-tabs-order-for-candidates',
    COMPANIES: 'profile-tabs-order-for-companies',
    CONTACTS: 'profile-tabs-order-for-contacts',
    HIRING_AUTHORITIES: 'profile-tabs-order-for-hiring-authorities',
    JOB_ORDERS: 'profile-tabs-order-for-job-orders'
  }),
  AI: {
    ASSISTANT_POSITION: 'ai-assistant-position'
  },
  SENDOUTS: {
    ACTIVITY_LOGS: 'sendouts-activity-logs',
    EMAILS: 'sendouts-emails'
  },
  TABLES: Object.freeze({
    AI_PROSPECTING_ASSISTANT_RESULTS: 'ai-prospecting-assistant-results',
    AI_PROSPECTING_ASSISTANT_COMPANY_RESULTS: 'ai-prospecting-assistant-company-results'
  }),
  CREATION: {
    JOB_ORDER_DRAFTS: 'new-job-order-drafts',
    CANDIDATE_DRAFTS: 'new-candidate-drafts'
  }
});
